
import {defineComponent, type PropType} from 'vue'
import {Card} from "./models/Card";

export default defineComponent({
    name: "Accordion",
    props: {
        // Permet de paramétrer le type d'un élement html, type h3 ou autre
        elementType: {
            type: String,
            default: 'div'
        },
        cards: {
            type: Array as PropType<Array<Card>>,
            required: true
        },
        isLinkTitle: {
            type: Boolean,
            required: false,
            default: false
        },
        accordionId: {
            type: String,
            required: false,
            default: null
        },
        oneAtTime: {
            type: Boolean,
            required: false,
            default: false
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        isLarge: {
            type: Boolean,
            required: false,
            default: false
        },
        disableExpandedBorders: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        classes() {
            let classes = ['card']
            if (!this.oneAtTime) {
                classes.push('multi')
            }
            if (this.isDisabled) {
                classes.push('disabledCard')
            }
            return classes
        }
    },
    mounted() {
        const root = this.$refs.root as HTMLElement;
        root.querySelectorAll('.collapse').forEach((el) => {
            el.addEventListener('shown.bs.collapse', (event: any) => {
                this.onCollapseChange(event.target.id, true)
            });
            el.addEventListener('hidden.bs.collapse', (event: any) => {
                this.onCollapseChange(event.target.id, false)
            });
        });
    },
    methods: {
        onCollapseChange(collapseId: string, isExpanded: boolean) {
            const card = this.cards.find(c => c.collapseId === collapseId);
            if (!card) return;
            this.$emit('on-toggle', card, isExpanded);
        }
    }
});
